import React from 'react';
import { radioPropTypes } from '@App/common/components/Radio/RadioPropTypes';
import RadioCommon from '@App/common/components/Radio/Radio';
import * as styles from './Radio.module.scss';
const Radio = props => /*#__PURE__*/React.createElement("div", {
  className: styles.root
}, /*#__PURE__*/React.createElement(RadioCommon, Object.assign({
  id: props.id,
  name: props.name,
  value: props.value,
  classname: styles.rootInput
}, props)), (props === null || props === void 0 ? void 0 : props.label) && /*#__PURE__*/React.createElement("label", {
  className: `${styles.rootLabel} ${props.error ? styles.rootLabelError : ''}`,
  htmlFor: props.name
}, props.label));
export default Radio;